import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { AlertTriangle } from 'lucide-react';
import { apiFetch } from '@/lib/api';
import { useT } from '@/lib/i18n';

// DeletionBanner — aviso global enquanto houver EXCLUSÃO DEFINITIVA agendada (janela
// de arrependimento). Mostra a contagem regressiva e o botão de cancelar em qualquer
// tela, para o cliente não esquecer. Só admin (o endpoint exige).
export function DeletionBanner() {
  const t = useT();
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ['account-deletion-status'],
    queryFn: async (): Promise<{ pending: boolean; run_after?: string }> => {
      const r = await apiFetch('GET', '/account/delete/status');
      return (r.ok ? r.data : { pending: false }) as { pending: boolean; run_after?: string };
    },
    refetchInterval: 30000,
  });
  if (!data?.pending) return null;
  const mins = data.run_after ? Math.max(0, Math.round((new Date(data.run_after).getTime() - Date.now()) / 60000)) : 0;
  const cancel = async () => {
    const r = await apiFetch('POST', '/account/delete/cancel');
    if (!r.ok) { toast.error(t('account.del.cancelFailed')); return; }
    toast.success(t('account.del.canceledToast'));
    qc.invalidateQueries({ queryKey: ['account-deletion-status'] });
  };
  return (
    <div className="mb-4 flex items-center gap-3 rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
      <AlertTriangle className="size-4 shrink-0" />
      <span className="min-w-0 flex-1 font-medium">{t('account.del.banner', { mins })}</span>
      <button onClick={cancel} className="shrink-0 rounded-md border border-destructive/40 px-2.5 py-1 text-xs font-semibold transition-colors hover:bg-destructive/10">{t('account.del.cancel')}</button>
    </div>
  );
}
